import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=f29ba196&scoped=true&"
import script from "./customPage.vue?vue&type=script&lang=js&"
export * from "./customPage.vue?vue&type=script&lang=js&"
import style0 from "./customPage.vue?vue&type=style&index=0&id=f29ba196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29ba196",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f29ba196')) {
      api.createRecord('f29ba196', component.options)
    } else {
      api.reload('f29ba196', component.options)
    }
    module.hot.accept("./customPage.vue?vue&type=template&id=f29ba196&scoped=true&", function () {
      api.rerender('f29ba196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/customPage.vue"
export default component.exports